import {metadaApi} from '@dms/api/base';

import {getServiceOrderImportInvalidationTags} from '../utils/getServiceOrderImportInvalidationTags';
import {
  GetHyundaiAs1qUserOptionsApiArg,
  GetHyundaiAs1qUserOptionsApiArgSchema,
  GetHyundaiAs1qUserOptionsApiResponse,
  GetHyundaiAs1qUserOptionsApiResponseSchema,
  PostHyundaiAs1qRetrieveApiArg,
  PostHyundaiAs1qRetrieveApiArgSchema,
  PostHyundaiAs1qRetrieveApiResponse,
  PostHyundaiAs1qRetrieveApiResponseSchema,
} from './types';

export const metadaHyundaiAs1qApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getHyundaiAs1qUserOptions: build.query<
      GetHyundaiAs1qUserOptionsApiResponse,
      GetHyundaiAs1qUserOptionsApiArg
    >({
      query: () => ({
        url: `hyundai_omnetic/v1/v1/quotations/user-options`,
      }),
      providesTags: ['hyundaiAs1qUserOptions'],
      extraOptions: {
        responseSchema: GetHyundaiAs1qUserOptionsApiResponseSchema,
        requestSchema: GetHyundaiAs1qUserOptionsApiArgSchema,
      },
    }),
    postHyundaiAs1qRetrieve: build.mutation<
      PostHyundaiAs1qRetrieveApiResponse,
      PostHyundaiAs1qRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `hyundai_omnetic/v1/v1/quotations/retrieve`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        ...getServiceOrderImportInvalidationTags(queryArg.body),
        'hyundaiAs1qUserOptions',
      ],
      extraOptions: {
        responseSchema: PostHyundaiAs1qRetrieveApiResponseSchema,
        requestSchema: PostHyundaiAs1qRetrieveApiArgSchema,
      },
    }),
  }),
});

export const {useGetHyundaiAs1qUserOptionsQuery, usePostHyundaiAs1qRetrieveMutation} =
  metadaHyundaiAs1qApi;
